import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {SeparateRgbSockets} from "#material/nodes/converter/separate-rgb/definition"
import {separateRgbDefinition} from "#material/nodes/converter/separate-rgb/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeRGBColor} from "#material/three/three-utils"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import {cyclesColor} from "#material/cycles/helpers"
import type {ThreeReturns} from "#material/sockets/three"
import type {SeparateRgbNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class SeparateRgb extends MaterialNode<SeparateRgbSockets> {
    public override get definition() {
        return separateRgbDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<SeparateRgbSockets>> => {
        const color =
            (await evaluator.get(this.parameters.inputs.image))?.toColor() ??
            threeRGBColor({r: this.parameters.settings.r ?? 0, g: this.parameters.settings.g ?? 0, b: this.parameters.settings.b ?? 0})
        return {
            r: color.r,
            g: color.g,
            b: color.b,
        }
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<SeparateRgbSockets>> => {
        const separateRgb: SeparateRgbNode = {
            type: "separate_rgb",
            inputs: {color: await evaluator.get(this.parameters.inputs.image)},
            parameters: {color: cyclesColor(this.parameters.settings.image)},
            resources: {},
        }

        return {
            r: [separateRgb, "r"],
            g: [separateRgb, "g"],
            b: [separateRgb, "b"],
        }
    }
}
